// #region Imports

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// #endregion

ReactDOM.render(<App />, document.getElementById('root'));
